import script from "./zhiwuduotiao.vue?vue&type=script&setup=true&lang=js"
export * from "./zhiwuduotiao.vue?vue&type=script&setup=true&lang=js"

import "./zhiwuduotiao.vue?vue&type=style&index=0&id=0dcbabd4&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0dcbabd4"]])

export default __exports__